import { Injectable } from '@angular/core';
import { CHARTS_LEGEND_ALIGNMENT_MAPPING, WidgetType, chartTypes, widgetType_Chart_Mapping } from '../shared-configs/chart.config';
import { VlDataService } from '../vl-data/vl-data.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { APIConfigMapping } from '../vl-http/api-mapping-config.cnst';
import { HTTPAPIConfig } from '../vl-http/http-api.config';
import { VlHttpService } from '../vl-http/vl-http.service';

@Injectable({
  providedIn: 'root'
})
export class HighchartsRendererService {

  legendAlignments = CHARTS_LEGEND_ALIGNMENT_MAPPING

  constructor(private dataService: VlDataService, private httpService: VlHttpService,) { }

  transoformSourceDataToChartData(sourceData: any, chartConfig: any, widgetType: WidgetType) {
    let outPutChartConfig = this.dataService.deepClone(widgetType_Chart_Mapping[widgetType])
    outPutChartConfig.series = chartConfig?.yAxisProperties?.individualSeriesProperties?.map((prop: any) => ({
    name: prop.label,
    data: sourceData.map((row: any) => Number(row[prop.key])),
    color: prop.color,
    yAxis: prop.yAxis
    }));
    if (widgetType == chartTypes.fixedBarChart) {
      outPutChartConfig.series = chartConfig?.fixedChartYAxisProperties?.yAxis1SeriesProperties?.map((prop: any, index: number) => ( {
        name: prop.label,
        data: sourceData.map((row: any) => Number(row[prop.key])),
        color: prop.color,
        yAxis: 0,
        pointPadding: 0.2 + index / 10,
        pointPlacement: -0.2
      }))

      outPutChartConfig.series = [...outPutChartConfig?.series, ...chartConfig?.fixedChartYAxisProperties?.yAxis2SeriesProperties?.map((prop: any, index: number) => ({
        name: prop.label,
        data: sourceData.map((row: any) => Number(row[prop.key])),
        color: prop.color,
        yAxis: 1,
        pointPadding: 0.3 + index / 10,
        pointPlacement: 0.2
      }))];
    }
    let align = this.legendAlignments[chartConfig.legendPropertyies.legendAlignment]?.legendOption.align
    let vAlign = this.legendAlignments[chartConfig.legendPropertyies.legendAlignment]?.legendOption.verticalAlign
    outPutChartConfig.legend = {
      enabled: chartConfig.legendPropertyies.displayLegend ?? false,
      align: align ? align : 'left',
      verticalAlign: vAlign ? vAlign : 'bottom'
    }
    outPutChartConfig.title.text = chartConfig.title;
    switch(widgetType) {
      case chartTypes.stackBarChart:
      outPutChartConfig.xAxis.title.text = chartConfig.xAxisProperties.label;
      outPutChartConfig.yAxis.title.text = chartConfig?.yAxisProperties?.label;
      outPutChartConfig.plotOptions.column.dataLabels.enabled = chartConfig?.yAxisProperties?.stackLabels;
      outPutChartConfig.yAxis.stackLabels.enabled = chartConfig?.yAxisProperties?.dataLabels;
      outPutChartConfig.xAxis.categories = sourceData.map((row: any) => row[chartConfig.xAxisProperties.categories]);
      break;
      case chartTypes.barChart:
       outPutChartConfig.xAxis.title.text = chartConfig.xAxisProperties.label;
       outPutChartConfig.yAxis.title.text = chartConfig?.yAxisProperties?.label;
       outPutChartConfig.plotOptions.column.dataLabels.enabled = chartConfig?.yAxisProperties?.dataLabels;
       outPutChartConfig.xAxis.categories = sourceData.map((row: any) => row[chartConfig.xAxisProperties.categories]);
       break;
      case chartTypes.lineChart:
       outPutChartConfig.xAxis.title.text = chartConfig.xAxisProperties.label;
       outPutChartConfig.yAxis.title.text = chartConfig?.yAxisProperties?.label;
       outPutChartConfig.xAxis.categories = sourceData.map((row: any) => row[chartConfig.xAxisProperties.categories]);
       break;
       case chartTypes.fixedBarChart:
        outPutChartConfig.title.text = chartConfig?.title;
        outPutChartConfig.yAxis[0].title.text = chartConfig?.fixedChartYAxisProperties?.label1;
        outPutChartConfig.yAxis[1].title.text = chartConfig?.fixedChartYAxisProperties?.label2;
        outPutChartConfig.xAxis.categories = sourceData.map((row: any) => row[chartConfig.xAxisProperties.categories]);
        break;

      case chartTypes.pieChart:
      case chartTypes.donutChart:
        const pieChartData = sourceData.map((row: any) => ({
          name: row[chartConfig.xAxisProperties.label],
          y: Number(row[chartConfig.xAxisProperties.categories])
        }));

        outPutChartConfig.series = [{
          name: chartConfig.xAxisProperties.label,
          colorByPoint: true,
          data: pieChartData
        }];

        outPutChartConfig.legend = {
          enabled: chartConfig.legendPropertyies.displayLegend ?? false,
          align: align ? align : 'left',
          verticalAlign:  vAlign ? vAlign : 'bottom'
        }
        outPutChartConfig.plotOptions.pie.showInLegend = chartConfig.legendPropertyies.displayLegend ?? false;
        break;
    }
    return outPutChartConfig;
  }


  private displayWidgetDataConfigSubject: BehaviorSubject<boolean>  = new BehaviorSubject<boolean>(false);
  displayWidgetDataConfigSubscriber$: Observable<boolean> = this.displayWidgetDataConfigSubject.asObservable();

  SetUpdatedDisplayWidgetDataConfig(event: boolean) {
    this.displayWidgetDataConfigSubject.next(event);
  }

  getUpdatedDisplayWidgetDataConfig() {
    return this.displayWidgetDataConfigSubject.value;
  }


  getEntitySubmissionData(entityId: string): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITY_SUBMISSIONS_DATA']);
      apiConfig.postData = {
        entity_id: entityId
      };
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error(error);
          observer.complete();
        }
      });
    })
  }
  
}
